const SOURCE_LABELS = {
  checkout: 'Shipping Checkout',
  batch: 'Shipping Batch',
};

const parseTimestamp = (value) => {
  if (!value) {
    return null;
  }
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null;
  }
  const parsed = new Date(value);
  return Number.isFinite(parsed.getTime()) ? parsed : null;
};

const resolveShipmentSource = (shipment = {}) => {
  if (shipment.checkoutSessionId || shipment.paymentIntentId) {
    return {
      type: 'checkout',
      checkoutSessionId: shipment.checkoutSessionId || null,
      paymentIntentId: shipment.paymentIntentId || null,
      label: SOURCE_LABELS.checkout,
    };
  }

  const normalizedSource =
    typeof shipment.source === 'string' && shipment.source.length
      ? shipment.source
      : 'shippingBatches';

  return {
    type: 'batch',
    batchId: shipment.batchId || shipment.id || null,
    source: normalizedSource,
    label: SOURCE_LABELS.batch,
  };
};

export const aggregateLockerShipments = (shipments = []) => {
  if (!Array.isArray(shipments)) {
    return [];
  }

  return shipments
    .map((shipment) => {
      const items = Array.isArray(shipment?.items) ? shipment.items : [];
      const shippedAt = parseTimestamp(
        shipment?.shippedAt || shipment?.deliveredAt || shipment?.createdAt,
      );
      const createdAt = parseTimestamp(shipment?.createdAt) || shippedAt;
      const source = resolveShipmentSource(shipment);
      const itemCount = Number.isFinite(shipment?.itemCount)
        ? shipment.itemCount
        : items.length;

      return {
        id: shipment?.id || `${source.type}-${createdAt?.getTime() || 'pending'}`,
        shipmentId: shipment?.id || null,
        source,
        status: shipment?.status || 'processing',
        shippingFee:
          typeof shipment?.shippingFee === 'number' ? shipment.shippingFee : 0,
        deliveryEstimate: shipment?.deliveryEstimate || null,
        trackingNumber:
          shipment?.trackingNumber || shipment?.tracking?.number || null,
        shippedAt,
        createdAt,
        items,
        itemCount,
      };
    })
    .sort((a, b) => {
      const dateA = a.shippedAt?.getTime() || a.createdAt?.getTime() || 0;
      const dateB = b.shippedAt?.getTime() || b.createdAt?.getTime() || 0;
      return dateB - dateA;
    });
};

export const formatShipmentDate = (date) => {
  if (!(date instanceof Date) || !Number.isFinite(date.getTime())) {
    return 'Shipping';
  }
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
  }).format(date);
};

